import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Endpoints } from '../resources/endpoints';
import { catchError, map, mergeMap, switchMap } from 'rxjs/operators';
import { Company } from '../interfaces/company';
import { Router } from '@angular/router';
import { environment } from './../../../environments/environment';
import { User } from './../interfaces/user';
import { RoleService } from './role.service';
import { Role } from './../interfaces/role';
import { NgxSpinnerService } from 'ngx-spinner';
import { FullUser } from '../interfaces/fullUser';
import { Cargo } from '../interfaces/cargo';
import { Utils } from '../resources/utils';
import __roleMaster from '__mock/roleMaster.json';
import { CatalogItem } from '../interfaces/catalogItem';
import { Catalog } from '../interfaces/catalog';
import { TermsAndConditions } from '../interfaces/termsAndConditions';
import * as firebase from 'firebase/app';
import 'firebase/auth';
import { UserClient } from '../interfaces/userClient';
import { UserClientModel } from '../models/userClient.model';
import { AccountService } from 'src/app/modules/account/account.service';
import { MatDialog } from '@angular/material/dialog';
import { SnackBarService } from './snackBar.service';
import { ServiceMessages } from '../messages/service-messages.enum';
import { Global } from '../resources/global';
import { DocumentTypeEnum } from '../enums/document-type.enum';
import { ConfigurationSaaS, SaasConfig, ServiceType, Setting, SettingId } from '../interfaces/saas-config';
import { Fmt } from '../messages/fmt';
import { Observable, throwError, from } from 'rxjs';
import { StorageService } from './storage.service';
import { Vehicle } from '../interfaces/vehicle';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  public static userInstance = new UserClientModel();

  public static afAuth: firebase.auth.Auth;
  public static fStorage: firebase.storage.Storage;
  public static fDatabase: firebase.database.Database;
  public static fFirestore: firebase.firestore.Firestore;
  public global: Global
  public static watchdogActive = false;
  public settingsSaasCompany: Setting[];
  public configurationsSaasCompany: ConfigurationSaaS[];
  public static userListener
  public static fcmSubscriptionCleanup: () => Promise<void> = () => Promise.resolve();
  private WatchDog = () => {
    const document: string = AuthService.userInstance.information.document;
    if (document.length) {
      import('../classes/firebase-api')
        .then(F => {
          const api = F.FirebaseApi;
          AuthService.userListener = api.firestore
            .collection('UserClient')
            .doc(document)
            .onSnapshot(async (snapshot) => {
              const user = snapshot.data();
              const active = user.state && user.state.active;
              const isPending = user.role === "webUserPendingActivate";
              if (!active && !isPending) {
                // Logout
                await this.attemptLogout();
                F.FirebaseApi
                  .auth
                  .signOut()
                  .then(() => {
                    F.FirebaseApi.close();
                    this.dialog.closeAll();
                    this.router.navigate(['/account/login']);
                    this.snackBarService.openSnackBar('Su cuenta está deshabilitada.', 'x', 'error');
                  });
              }
            });
        })
    }

  };

  public cargoActive: { cargo: Cargo, negotiation: any, negotiationRequest: any } = {
    cargo: null,
    negotiation: {
      state: null,
      driver: null,
      negotiatedValueDriver: null,
      negotiatedValueCreator: null
    },
    negotiationRequest: {
      state: null,
      companyId: null,
      negotiatedValueCompany: null,
      negotiatedValueCreator: null
    }
  };
  public companyInstance: Company;
  public companySaaS: Company;
  public static companies: Company[] = [];
  public static gps: CatalogItem[] = [];

  constructor(
    private router: Router,
    private http: HttpClient,
    private endpointResources: Endpoints,
    private roleService: RoleService,
    private accountService: AccountService,
    private spinner: NgxSpinnerService,
    public utils: Utils,
    public dialog: MatDialog,
    private snackBarService: SnackBarService,
  ) {

  }

  public checkRegisteredUser(email: string) {
    return this.http.get<FullUser>(
      environment.urlServerTeclogi + this.endpointResources.configUser + email.toLocaleLowerCase()
    );
  }

  public getFullUserByEmail(email: string) {
    return this.http.get<FullUser>(
      environment.urlServerTeclogi + this.endpointResources.configUser + email.toLocaleLowerCase()
    ).pipe(
      catchError(error => {
        console.error(error);
        throw this.errorDetailUserByEmail('user', null, error);
      }),
      switchMap((userData: FullUser) => {
        const active = this.utils.getNestedValue(userData, 'user.state.active')
        const isPending = this.utils.getNestedValue(userData, 'user.role') === "webUserPendingActivate";
        if (active || isPending) {
          this.validateDetailUserByEmail(userData);
          if (!AuthService.watchdogActive) {
            AuthService.watchdogActive = true;
            this.WatchDog();
          }
          return from(Promise.resolve(userData));
        } else {
          this.clearSession();
          return throwError(() => new Error('Usuario inactivo - sesión cerrada'));
        }
      })
    );
  }

  public getAllCompanies() {
    return this.http.get<Company[]>(
      environment.urlServerTeclogi + this.endpointResources.getAllCompanies
    ).pipe(
      map((data: Company[]) => {
        this.setCompanies(data);
      })
    );
  }

  public getAllTypesGps() {
    return this.http.get<Catalog>(
      environment.urlServerTeclogi + this.endpointResources.getAllTypesGps
    ).pipe(
      map((data: Catalog) => {
        if (data && data.catalog) {
          this.setGPS(data.catalog);
        } else {
          this.setGPS([]);
        }
      })
    );
  }

  public getFullUserByPhone(phone: string) {
    return this.http.get<User>(
      environment.urlServerTeclogi + this.endpointResources.getUserPhone + phone
    ).pipe(
      catchError(error => {
        console.error(error);
        return error;
      }),
      map((userData: User) => {
        this.setUserSessionPhone(userData);
        return userData;
      })
    );
  }

  private errorDetailUserByEmail(tag, dataUser, error) {
    if (dataUser) {
      return this.validateDetailUserByEmail(dataUser);
    } else {
      error.tag = tag;
      return error;
    }
  }

  private async validateDetailUserByEmail(dataUser: FullUser) {
    let user: UserClient;
    let role: Role;
    let company: Company;

    if (dataUser) {
      if (dataUser.user) {
        user = dataUser.user;
        if (dataUser.role) {
          role = dataUser.role;
          this.roleService.setRoleUser(role);
        }
        if (dataUser.company) {
          company = dataUser.company;
          this.setCompany(company).catch(error => {
            console.warn('Error setting company:', error);
          });
        }
        if (StorageService.checkStorage().getItem('_companyId')) {
          this.setCompanySaaS(StorageService.checkStorage().getItem('_companyId'));
        }
        this.setUserSession(user);
        if ((!user.lastUserTerm) || (user.lastUserTerm && !user.lastUserTerm.state)) {
          this.spinner.hide();
          this.router.navigate(['/account/validate-terms']);
        }
        return user;
      }
    }
    await this.attemptLogout();
  }

  public getDetailCompany(nit: string) {
    return this.http.get(
      environment.urlServerTeclogi + this.endpointResources.urlDetailCompany + nit
    ).pipe(
      map(
        (dataCompany: Company) => {
          if (dataCompany) {
            this.setCompany(dataCompany);
            return this.getCompany();
          } else {
            this.logOut();
            this.clearSession();
            this.dialog.closeAll();
            this.router.navigate(['/account/login']);
          }
        }
      )
    );
  }

  public userIsFromRootNit(): boolean {
    try {
      const companies = this.accountService.listRegisterCompanies();
      return companies &&
        this.getUserSession() &&
        this.getUserSession().clientCompanyId &&
        companies.some(company => company.nit === this.getUserSession().clientCompanyId);
    } catch {
      return false;
    }
  }

  public setUserSessionPhone(user: User) {

    AuthService.userInstance.deserialize(user);
    if (user && user.phone) {
      StorageService.checkStorage().setItem('_phone', user.phone);
    }
  }

  public signUp(email, password) {
    return AuthService.afAuth.createUserWithEmailAndPassword(email, password);
  }

  public getCurrentUserFirebase() {
    return AuthService.afAuth.currentUser;
  }


  public onAuthChange(callback: (user: firebase.User | null) => void) {
    AuthService.afAuth.onAuthStateChanged(callback);
  }


  public signIn(email, password) {
    return AuthService.afAuth.signInWithEmailAndPassword(email, password);
  }

  public signInGoogle() {
    sessionStorage.setItem('_PendingSSO', "true");
    const provider = (
      environment.production ?
        //@ts-ignore
        new firebase.auth.SAMLAuthProvider('saml.workspace') :
        new firebase.auth.GoogleAuthProvider()
    );
    return AuthService.afAuth.signInWithPopup(provider);
  }

  public signInCredential(credential: firebase.auth.AuthCredential) {
    return AuthService.afAuth.signInWithCredential(credential);
  }

  private async logOut() {
    try {
      console.log('[Notifications] Running FCM subscription cleanup before logout');
      await AuthService.fcmSubscriptionCleanup();
    } catch (error) {
      console.error('[Notifications] Error unregistering FCM subscription on logout', error);
    }

    firebase.app().delete();
    AuthService.userInstance = new UserClientModel();
    const signInType = sessionStorage.getItem('signInType');
    sessionStorage.clear();
    this.resetCompanyConfig();
    if (signInType !== null) sessionStorage.setItem('signInType', signInType);
    if (AuthService.afAuth)
      return AuthService.afAuth.signOut();
  }

  private resetCompanyConfig() {
    AuthService['companySaaS'] = null;
    AuthService['companyInstance'] = null;
    AuthService['settingsSaasCompany'] = null;
    AuthService['configurationsSaasCompany'] = null;
    AuthService['configSaasCompany'] = null;
    AuthService.watchdogActive = false;
    if (AuthService.userListener) AuthService.userListener();
    this.setCompanies(null);
    this.roleService.setRoleUser(null);
    this.setGPS([]);
  }

  public async attemptLogout() {
    try {
      await this.logOut();
      await this.updateUId(null, true).toPromise();
      this.clearSession();
      this.router.navigate(['/account/login']);
      return true;
    } catch (error) {
      console.error("error in attemptLogout", error);
      this.snackBarService.openSnackBar(ServiceMessages.ERROR_ATTEMPT_LOGOUT, undefined, 'error');
      return false;
    }
  }

  public clearSession() {
    sessionStorage.removeItem('_lastList');
    sessionStorage.removeItem('_freightActive');
    StorageService.checkStorage().removeItem('firebaseAppConfig');
    StorageService.checkStorage().removeItem('_token');
    StorageService.checkStorage().removeItem('_email');
    StorageService.checkStorage().removeItem('_phone');
    StorageService.checkStorage().removeItem('_companyId');
  }

  public sessionActive() {
    return !!this.getUserSession() && !!this.getUserSession().email;
  }

  public setUserSession(user: User) {

    AuthService.userInstance.deserialize(user);

    if (user) {
      StorageService.checkStorage().setItem('_email', user.email);
    }
  }

  public getUserSession(): UserClientModel {
    return AuthService.userInstance;
  }

  public userSessionIsActive(): boolean {
    try {
      return !!this.getUserSession().state.active;
    } catch (e) {
      return false;
    }
  }

  public getCompanies(): Company[] {
    return AuthService.companies;
  }

  public setCompanies(companies) {
    AuthService.companies = companies;
  }

  public getGPS(): CatalogItem[] {
    return AuthService.gps;
  }

  public setGPS(gps) {
    AuthService.gps = gps;
  }

  public getCompany(): Company {
    return AuthService['companyInstance'] ? AuthService['companyInstance'] : null;
  }

  public getCompanySaaS(): Company {
    return AuthService['companySaaS'] ? AuthService['companySaaS'] : null;
  }

  public async setCompany(company: Company) {
    AuthService['companyInstance'] = company;
    try {
      firebase.firestore().collection('Company').doc(company.companyId).onSnapshot(
        (snapshot) => {
          const company = snapshot.data();
          AuthService['companyInstance'] = company;
        },
        (error) => {
          console.warn('Firebase listener error:', error);
        }
      );
    } catch (error) {
      console.warn('Firebase not available, skipping listener');
    }
  }

  public setCompanySaaS(nit: string) {
    return this.http.get(
      environment.urlServerTeclogi + this.endpointResources.urlDetailCompany + nit
    ).subscribe(
      async (dataCompany: Company) => {
        if (dataCompany) {
          AuthService['companySaaS'] = dataCompany;
          this.setSettingsSaasCompany();
          this.setConfigurationsSaasCompany();
          this.setCompanySaaSConfig(dataCompany);
          firebase.firestore().collection('Company').doc(dataCompany.companyId).onSnapshot(
            (snapshot) => AuthService['companySaaS'] = snapshot.data()
          )
        } else {
          await this.attemptLogout();
        }
      }, () => AuthService['companySaaS'] = null
    );
  }

  public setCompanyFieldsExcelCargo(fields) {
    if (AuthService['companyInstance']) {
      AuthService['companyInstance'].fieldsExcelCargo = this.utils.clone(fields);
    }
  }

  public userActive(): boolean {
    return AuthService.userInstance ? (AuthService.userInstance.state.active ? true : false) : false;
  }

  public setToken(token: any) {
    if (token) StorageService.checkStorage().setItem('_token', token);
  }

  public resetPassword(email: string) {
    return AuthService.afAuth.sendPasswordResetEmail(email);
  }

  public getTokenUser() {
    return AuthService.afAuth.currentUser.getIdTokenResult();
  }


  public getCurrentTokenUser() {
    return AuthService.afAuth.currentUser.getIdToken();
  }

  public validateUser(): Promise<boolean> {
    return new Promise((resolve, reject) => {
      if (this.getUserSession() && this.getUserSession().information.document) {
        resolve(true);
      } else {
        if (StorageService.checkStorage().getItem('_email')) {
          this.getFullUserByEmail(StorageService.checkStorage().getItem('_email')).subscribe(
            (success) => {
              resolve(true);
            },
            (error) => {
              console.error(error);
              reject(false);
            }
          );
        } else if (StorageService.checkStorage().getItem('_phone') || sessionStorage.getItem('_phone')) {
          const phone = StorageService.checkStorage().getItem('_phone') || sessionStorage.getItem('_phone');
          this.getFullUserByPhone(phone).subscribe(
            (success) => {
              resolve(true);
            },
            (error) => {
              console.error(error);
              reject(false);
            }
          );
        } else {
          reject(false);
        }
      }
    });
  }

  public updateUId(uId?: string, onlyUpdate?: boolean): Observable<any> {
    let params = new HttpParams();
    params = params.append('document', this.getUserSession().information.document);
    params = params.append('uId', uId);
    const updateRequest = this.http.put(
      environment.urlServerTeclogi + this.endpointResources.urlUpdateUId,
      {},
      { params }
    )
    if (onlyUpdate) return updateRequest;
    return updateRequest.pipe(
      mergeMap((data) => this.getFullUserByEmail(this.getUserSession().email))
    );
  }

  public userClientUpdateTerms(userId: string, body: TermsAndConditions) {
    let params = new HttpParams();
    params = params.append('userId', userId);
    return this.http.put(
      environment.urlServerTeclogi + this.endpointResources.urlUserClientUpdateTerms,
      body,
      { params }
    ).pipe(
      mergeMap((data) => this.getFullUserByEmail(this.getUserSession().email))
    );
  }

  async signInWithCustomToken(token: string, email: string) {
    try {
      const result = await AuthService.afAuth.signInWithCustomToken(token);
      this.setToken(result.user.uid);
      this.getDetailUserByEmail(email);
    } catch (error) {
      let errorMessage = '';
      switch (error.code) {
        case 'auth/email-already-in-use':
          errorMessage = "La dirección de correo electrónico ya está en uso por otra cuenta.";
          break;
        case 'auth/wrong-password':
          errorMessage = "La contraseña no es válida o el usuario no tiene una contraseña.";
          break;
        case "auth/user-disabled":
          errorMessage = "La cuenta de usuario ha sido deshabilitada por un administrador.";
          break;
        case "auth/user-not-found":
          errorMessage = "El usuario no está registrado";
          break;
        case "auth/internal-error":
          errorMessage = "Usuario o contraseña incorrectos";
          break;
        default:
          errorMessage = 'Ocurrió un error para acceder a la cuenta';
          break;
      }
      this.snackBarService.openSnackBar(errorMessage, undefined, 'error');
    }
  }


  getDetailUserByEmail(email: string, sso_meta?: any) {
    const $ = this.getFullUserByEmail(email)
      .subscribe(
        {
          next: () => {
            if (
              this.utils.isDefined(this.getUserSession().information.document) &&
              !this.utils.isEmpty(this.getUserSession().information.document)
            ) {
              this.router.navigate(['/home']);
            } else if (!!sso_meta) {
              // Registrar al usuario desde el SSO
              let user: UserClient = null;
              try {
                user = {
                  information: this.getInformationFromMeta(sso_meta),
                  email: sso_meta.user.email,
                  clientCompanyId: environment.rootNit,
                  phone: sso_meta.additionalUserInfo.profile.phone,
                  role: this.global.defaultRoles.webUserPendingActivate.id,
                  lastUserTerm: null
                }
              } catch (e) {
                return;
              }
            } else {
              this.snackBarService.openSnackBar(ServiceMessages.GENERAL_RETRY_INDICATION, undefined, 'error');
              this.logOut();
            }
          },
          error: () => {
            this.logOut();
            this.snackBarService.openSnackBar(ServiceMessages.GENERAL_RETRY_INDICATION, undefined, 'error');
            this.spinner.hide();
          },
          complete: () => {
            $.unsubscribe();
          }
        }
      );
  }

  private getInformationFromMeta(meta) {
    let documentTypeId, documentTypeName, document, sigla;

    [sigla, document] = meta.additionalUserInfo.profile.document_id.split(':');
    switch (sigla) {
      case DocumentTypeEnum.CEDULA_CIUDADANIA:
        documentTypeId = '1';
        documentTypeName = 'Cédula de ciudadanía';
        break;
      case DocumentTypeEnum.PASAPORTE:
        documentTypeId = '2';
        documentTypeName = 'Pasaporte';
        break;
      case DocumentTypeEnum.NIT:
        documentTypeId = '3';
        documentTypeName = 'NIT';
        break;
      default:
        throw new Error();
    }

    return {
      document,
      documentTypeId,
      documentTypeName,
      name: `${meta.additionalUserInfo.profile.name} ${meta.additionalUserInfo.profile.lastname ? meta.additionalUserInfo.profile.lastname : ''}`,
    };
  }

  public setSettingsSaasCompany() {
    const settingSaasObserver = {
      next: (settings: Setting[]) => {
        this.spinner.hide();
        if (settings && settings.length > 0) AuthService['settingsSaasCompany'] = settings;
        else AuthService['settingsSaasCompany'] = [];
      },
      error: (error) => {
        this.spinner.hide();
        console.error(error);
        AuthService['settingsSaasCompany'] = [];
      }
    }
    this.spinner.show();
    this.querySettingsSaasCompany().subscribe(settingSaasObserver);
  }

  public setCompanySaaSConfig(company: Company) {
    this.http.get<Setting[]>(`${environment.urlServerTeclogi}${Fmt.string(this.endpointResources.getCompanySaaS, company.companyId)}`).subscribe(
      (settings: Setting[]) => {
        AuthService['configSaasCompany'] = settings;
      }
    );
  }
  public getCompanySaaSConfig(): SaasConfig {
    return AuthService['configSaasCompany'];
  }

  public getSettingsSaasCompany(): Setting[] {
    return AuthService['settingsSaasCompany'];
  }
  public querySettingsSaasCompany() {
    return this.http.get<Setting[]>(`${environment.urlServerTeclogi}${Fmt.string(this.endpointResources.getSaasConfig, this.getCompanySaaS().companyId)}`);
  }

  public changeSettingsSaasCompany(body: Setting) {
    return this.http.put(`${environment.urlServerTeclogi}${Fmt.string(this.endpointResources.getSaasConfig, this.getCompanySaaS().companyId)}`, body);
  }

  // Crea settings de la SaaS (POST). El PUT (changeSettingsSaasCompany) solo actualiza settings ya existentes.
  public registerSettingsSaasCompany(body: Setting[]) {
    return this.http.post(`${environment.urlServerTeclogi}${Fmt.string(this.endpointResources.getSaasConfig, this.getCompanySaaS().companyId)}`, body);
  }

  public async setConfigurationsSaasCompany() {
    try {
      const configurations = await this.queryConfigurationsSaasCompany().toPromise();
      if (configurations && configurations.length > 0) AuthService['configurationsSaasCompany'] = configurations;
      else AuthService['configurationsSaasCompany'] = [];
    } catch (error) {
      console.error(error);
      AuthService['configurationsSaasCompany'] = [];
    }
  }

  public async refreshSettingsSaasCompany(): Promise<void> {
    try {
      const settings = await this.querySettingsSaasCompany().toPromise();
      AuthService['settingsSaasCompany'] = (settings && settings.length) ? settings : [];
    } catch (error) {
      console.error(error);
    }
  }

  public queryConfigurationsSaasCompany() {
    return this.http.get<ConfigurationSaaS[]>(
      `${environment.urlServerTeclogi}${Fmt.string(this.endpointResources.saasConfigurations, this.getCompanySaaS().companyId)}`
    );
  }

  public getConfigurationsSaasCompany(): ConfigurationSaaS[] {
    return AuthService['configurationsSaasCompany'] || [];
  }

  public createConfigurationSaasCompany(body: ConfigurationSaaS) {
    return this.http.post(
      `${environment.urlServerTeclogi}${Fmt.string(this.endpointResources.saasConfigurations, this.getCompanySaaS().companyId)}/${body.id}`,
      body
    );
  }

  public changeConfigurationSaasCompany(body: ConfigurationSaaS) {
    return this.http.put(
      `${environment.urlServerTeclogi}${Fmt.string(this.endpointResources.saasConfigurations, this.getCompanySaaS().companyId)}/${body.id}`,
      body
    );
  }

  public getConfigurationsSaasCompanyByName(name: string) {
    return this.http.get<ConfigurationSaaS[]>(
      `${environment.urlServerTeclogi}${Fmt.string(this.endpointResources.saasConfigurations, this.getCompanySaaS().companyId)}/${name}`
    );
  }

  public generateCustomToken(data: any): Observable<{ token: string }> {
    return this.http.post<{ token: string }>(`${environment.urlServerInnovbo}/auth/token/generate`, data);
  }

  public redirectToLoggiCash() {
    //window.open(`http://localhost:8080/auth`, '_blank');
    window.open(`${environment.urlLoggiCashApp}/auth`, '_blank');
  }

  public hasCompanySettingEnabled(settingId: SettingId) {
    let settings = this.getSettingsSaasCompany();
    if (settings && settings.length) {
      const foundSetting = settings.find(setting => setting.id === settingId);
      return foundSetting && this.utils.isDefined(foundSetting.active) ? foundSetting.active : false;
    }
    return false;
  }

  public hasSettingAccess(functionality: string): boolean {
    let settings = this.getSettingsSaasCompany();
    if (!settings || !settings.length) return true;
    switch (functionality) {
      case "prevalidationCargos":
        return this.hasCompanySettingEnabled(SettingId.REQUIRES_PRE_VALIDATION);
      case "editTravelExpenses":
      case "removeTravelExpenses":
      case "removeAcceptedTravelExpenses":
      case "approvePaymentsWithTravelExpensesPending":
      case "payWithTravelExpenses":
      case "changeApprovedTravelExpenses":
      case "paymentTravelExpenses":
      case "travelExpensesChecking":
        return this.hasCompanySettingEnabled(SettingId.USE_TRAVEL_EXPENSES);
      default:
        return true;
    }
  }

  public createHolderObjReceivables(vehicle: Vehicle) {
    let user: string;
    if (this.utils.vehicleIsOwnFleet(vehicle, this.getCompanySaaSConfig()))
      user = 'driver';
    else {
      if (vehicle && vehicle.administrator) user = 'administrator';
      else user = 'owner';
    }
    return {
      name: this.utils.getNestedValue(vehicle, `${user}.name`) ? this.utils.getNestedValue(vehicle, `${user}.name`) : '',
      document: this.utils.getNestedValue(vehicle, `${user}.document`) ? this.utils.getNestedValue(vehicle, `${user}.document`) : '',
      documentTypeName: this.utils.getNestedValue(vehicle, `${user}.documentTypeName`) ? this.utils.getNestedValue(vehicle, `${user}.documentTypeName`) : ''
    }
  }

  /**
  * @returns {boolean} Returns true if the user's SaaS company has escort services
  * @description Verifies if the user's SaaS company has escort services
  */
  get hasEscortServicesCompany(): boolean {
    const saasConfig = this.getCompanySaaSConfig();
    return !!(saasConfig && saasConfig.serviceTypes && saasConfig.serviceTypes.includes(ServiceType.SECURITY_ESCORT))
  }

  /**
  * @returns {boolean} Returns true if the user's SaaS company has satellite lock services
  * @description Verifies if the user's SaaS company has satellite lock services
  */
  get hasSatelliteLockServicesCompany(): boolean {
    const saasConfig = this.getCompanySaaSConfig();
    return !!(saasConfig && saasConfig.serviceTypes && saasConfig.serviceTypes.includes(ServiceType.SATELLITE_LOCK))
  }

  /**
  * @returns {boolean} Returns true if the user's SaaS company has escort or satellite lock services
  * @description Verifies if the user's SaaS company has escort or satellite lock services
  */
  get hasTransportServicesCompany(): boolean {
    const saasConfig = this.getCompanySaaSConfig();
    return !!(saasConfig && saasConfig.serviceTypes && saasConfig.serviceTypes.includes(ServiceType.FREIGHT_TRANSPORT))
  }

}
